// main.js
import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import { initTheme } from "@/services/theme";
import { loadCompany } from "@/data/company";
import VueLoadingIndicator from '@nguyenshort/vue3-loading-indicator';
import Aos from "aos";
import 'aos/dist/aos.css'
// Template components
import BaseBlock from "@/components/BaseBlock.vue";
import BaseBackground from "@/components/BaseBackground.vue";
import BasePageHeading from "@/components/BasePageHeading.vue";

// Template directives
import clickRipple from "@/directives/clickRipple";

// Bootstrap framework
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@/assets/scss/main.scss';

import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;

// Toast notifications
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

// Craft new application
export const app = createApp(App);
Aos.init()
// Register global components
app.component("BaseBlock", BaseBlock);
app.component("BaseBackground", BaseBackground);
app.component("BasePageHeading", BasePageHeading);

// Register global directives
app.directive("click-ripple", clickRipple);

// Use Pinia and Vue Router
app.use(createPinia());
initTheme(); // светлая / тёмная / как в системе — до монтирования, чтобы не мигало
app.use(router);
app.use(Toast);
app.use(VueLoadingIndicator, {
  color: "#ff5400",         // Цвет прогресса
  errorColor: "#ff4d4d",    // Цвет ошибки (например, если запрос не удался)
  duration: 500,           // Длительность прогресса в миллисекундах (сколько времени будет отображаться прогресс-бар)
  timeGap: 100,             // Время между обновлениями прогресса (в миллисекундах)
  throttle: 50,             // Задержка обновлений прогресса (для уменьшения частоты обновлений)
  skipDuplicate: true,      // Пропускать дублирующиеся запросы (чтобы не запускать новый прогресс, если он уже есть)
  autoFinish: true,         // Автоматическое завершение прогресса при завершении запроса
  delay: 0              
      // Задержка перед началом прогресса (в миллисекундах)
})
loadCompany(); // контакты оператора, которые админ меняет в кабинете (страницы клиента)
app.mount("#app");


 
